<div class="container-detail">

   <div class="bg p-0">
      <div class="d-block d-xl-flex justify-content-between">
         <div class="col-12 col-xl-9 py-5">
            <div class="descriptionApplicant px-0 px-sm-3 px-lg-5">
               <h4 class="fs-22"><strong>Descripción de {{ hideNameCompany(developer?.company) }}</strong></h4>
               <div [innerHtml]="devDescription"></div>
            </div>
            <div class="locationsApplicants px-0 px-sm-3 px-lg-5" *ngIf="dev?.devInfoDetail?.mainLocation || dev?.devInfoDetail?.developerApproach">
               <div *ngIf="dev?.devInfoDetail?.mainLocation">
                  <h3 class="fw-bold fs-19 mt-5">Ubicaciones principales</h3>
                  <p class="fw-bold cl-pink fs-17">{{dev?.devInfoDetail?.mainLocation}}</p>
               </div>
               <div *ngIf="dev?.devInfoDetail?.developerApproach">
                  <h3 class="fw-bold fs-19 mt-5">Enfoque del desarollador:</h3>
                  <p class="fs-15 w-75">{{dev?.devInfoDetail?.developerApproach}}</p>
               </div>
            </div>
         </div>
         <div class="col-12 col-xl-3 bg-semiwhite">
            <div class="imageApplicant" *ngIf="dev?.devInfoDetail?.logoDevelopment else noHaveImageApplicant">
               <img [src]="dev?.devInfoDetail?.logoDevelopment" alt="Image" class="imageApplicant">
            </div>
            <ng-template #noHaveImageApplicant>
               <div class="imageApplicant">
                  <img [src]="dev?.location?.image" alt="Image" class="imageApplicant">
               </div>
            </ng-template>

            <hr>
            <div class="aboutApplicant text-center">
               <h3 class="fw-bold fs-16" *ngIf="dev?.devInfoDetail?.aboutApplicant || dev?.devInfoDetail?.linkWebSite">Más información del solicitante</h3>
               <p class="mt-4"><a class="cl-pink fw-sbold cr-pointer" *ngIf="dev?.devInfoDetail?.aboutApplicant" (click)="openLink(dev?.devInfoDetail?.aboutApplicant)">
                  <fa-icon [icon]="hotelIcon" class="me-2"></fa-icon> Conoce más al solicitante</a>
               </p>
               <p class="mt-4"><a class="cl-pink fw-sbold cr-pointer" *ngIf="dev?.devInfoDetail?.linkWebSite" (click)="openLink(dev?.devInfoDetail?.linkWebSite)">
                  <fa-icon [icon]="websiteIcon" class="me-2"></fa-icon> Ir a sitio web</a>
               </p>
               <p class="mt-4"><a class="cl-pink fw-sbold cr-pointer" href="mailto:{{dev?.devInfoDetail?.chatWithApplicant}}?subject=Contacto&body=Escriba%20su%20mensaje..." *ngIf="dev?.devInfoDetail?.chatWithApplicant">
                  <fa-icon [icon]="emailIcon" class="me-2"></fa-icon>Contacta al solicitante</a>
               </p>
            </div>
         </div>
      </div>
   </div>

   <!-- END | DESCRIPCIÓN -->


   <!-- PREMIOS -->
  <div class="py-4 py-lg-5 px-3 px-lg-5 text-center" *ngIf="dev?.location?.rewardsDev">
   <h4><strong>Premios del solicitante</strong></h4>

   <div class="row justify-content-center mt-4">
      <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-3" *ngFor="let r of rewardsDev">
        <div class="reward-container">
            <div class="img-container">
               <img [src]="r.img" alt="">
            </div>
            <p mat-raised-button #tooltip="matTooltip" [matTooltip]="r.title" class="text-truncate--4">{{ r.title }}</p>
            </div>
      </div>
     </div>

   </div>
   <!-- END | PREMIOS -->

   <div class="text-center mt-5 mb-5" *ngIf="percentDeveloper !== 0 && dev.monificPercent">
      <!-- <h5>{{ developer.company }}</h5> -->
      <h4><strong>Esquema de operación</strong></h4>
      <p class=" mx-auto w-50">
         Del <strong>100%</strong> del valor total, el dueño del hotel participa con el <strong>{{percentDeveloper}}%</strong> para buscar la buena operación, el rendimiento y desempeño de la inversión.
      </p>

      <div *ngIf="dev?.monificPercent">
         <div class="d-flex justify-content-center mb-3">
            <div class="square monific"></div>
            MONIFIC
            <div class="ms-3 square dev"></div>
            {{nameCompany || 'Desarrollador'}}
         </div>

         <div class="chart-container">
            <canvas id="percent-chart" height="125" width="125"></canvas>
         </div>
      </div>

   </div>

   <!-- <ng-template #isHouse>
      <div class="mt-5 mb-5 px-4">
         <h4 class="fs-22"><strong>Esquema de operación</strong></h4>
         <p>
            El esquema de operación para el proyecto se centra en un modelo colaborativo de inversión entre los participantes de Monific y "Compramos Tu Casa". Este enfoque se estructura de la siguiente manera:
         </p>
         <ul>
            <li><strong>Objetivo del financiamiento:</strong> Se busca recaudar $275,000.00 MXN para la compra de una propiedad residencial en una zona de alta demanda en la Ciudad de México.</li>
            <li><strong>Contribución de los inversionistas:</strong> Los inversionistas de Monific aportarán el capital necesario a través de participaciones en el proyecto.</li>
            <li><strong>Distribución de ganancias:</strong> Una vez adquirida y posteriormente vendida la propiedad, los inversionistas recibirán una regalía fija del 5.00%, reflejando un rendimiento anual atractivo en función del tiempo que tome la venta.</li>
            <li><strong>Plazos del proyecto:</strong> La inversión tiene un período mínimo de 3 meses y un máximo de 7 meses, con flexibilidad dependiendo de la rapidez de la venta de la propiedad.</li>
         </ul>
      </div>
   </ng-template> -->


   <!-- Subseccion del solicitante -->
   <div class="bg py-4 py-lg-5 px-3 px-lg-5">
      <div class="d-md-flex align-items-center-justify-content-md-around col-12">
         <div class="mb-5 mt-3 col-md-9 col-12" *ngIf="dev?.devInfoDetail?.operator">
            <h4 class="fs-22"><strong>Operador: {{dev?.devInfoDetail?.operator}}</strong></h4>
            <p [innerHTML]="dev?.devInfoDetail?.descriptionOperator"></p>
         </div>
         <img [src]="dev?.devInfoDetail?.logoOperator" class="d-block m-auto col-md-2 col-12" alt="">
      </div>


      <div class="d-xl-flex justify-content-xl-around d-block m-auto">
         <div class="col-12 col-xl-11">
            <div *ngIf="dev?.devInfoDetail?.mainLocationsApplicants" class="mt-5 mt-xl-0">
               <h4 class="fs-22"><strong>Ubicaciones principales:</strong></h4>
               <p class="cl-pink fw-bold" [innerHTML]="dev?.devInfoDetail?.mainLocationsApplicants"></p>
            </div>

            <div class="my-5" *ngIf="dev?.devInfoDetail?.applicantExperience">
               <h4 class="fs-22"><strong>Experiencias de la operadora</strong></h4>
               <p [innerHTML]="dev?.devInfoDetail?.applicantExperience"></p>
            </div>
         </div>
         <div class="col-12 col-xl-1">
            <div *ngIf="dev?.devInfoDetail?.webSiteOperator">
               <a class="cl-pink fw-bold cr-pointer" (click)="openLink(dev?.devInfoDetail?.webSiteOperator)">Ir a sitio web ➤</a>
            </div>
         </div>
      </div>

   </div>
   <!-- END SUBSECCIÓN -->

</div>
